import { Button, Container, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { HeaderComponent } from "../../components";
import image from "../../assets/images"



export const HomePage: React.FC<{}> = ({}) => {
  
  const [mensaje, setMensaje] = useState('');

  useEffect(() => {
    fetch('http://localhost:5000/api/user')
      .then((res) => res.json())
      .then((data) => setMensaje(data.mensaje));
  }, []);
  
  return (
    //<Container maxWidth="xl">
      <HeaderComponent 
      //title="Hola mundo" 
      image={<img src={image.CB_LogoRelleno}></img>}
      description={mensaje}
      //element={<Button fullWidth variant="contained">jjjjj</Button>}
      />
    //</Container>
  );
};